import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FingerPrintService {
visitorIdSubject= new BehaviorSubject<string>(null);
visitorId$=this.visitorIdSubject.asObservable();
  constructor() { }
  async getFingerprint():  Promise<void>  {
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    this.visitorIdSubject.next(result.visitorId)
  }
}
